import { Box } from '@mui/material';
import { GoogleLogo as GoogleLogonSvg } from 'assets/images';

function GoogleLogo({ height = 24 }: { height?: number }) {
  return (
    <Box
      height={height}
      width={height}
      sx={{
        '& svg': {
          width: 1,
          height: 1,
        },
      }}
    >
      <GoogleLogonSvg />
    </Box>
  );
}

export default GoogleLogo;
